import { render, staticRenderFns } from "./OkrGanhosBlock.vue?vue&type=template&id=66a43b82&scoped=true"
import script from "./OkrGanhosBlock.vue?vue&type=script&lang=js"
export * from "./OkrGanhosBlock.vue?vue&type=script&lang=js"
import style0 from "./OkrGanhosBlock.vue?vue&type=style&index=0&id=66a43b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a43b82",
  null
  
)

export default component.exports